export default __webpack_public_path__ + "static/media/message.846e8fda.svg";